import apiBase from "./ApiBase";
import axios from "axios";

export const axiosWithRefresh = async (axiosConfig) => {
  const cookies = apiBase.cookies;
  let token = cookies.get("auth_token");

  axiosConfig.headers = axiosConfig.headers || {};
  axiosConfig.headers.Authorization = `Bearer ${token}`;

  try {
    return await axios(axiosConfig);
  } catch (error) {
    const status = error.response?.status;

    if ((status === 401 || status === 440)) {
      try {
        const newToken = await apiBase.refreshToken();
        if (newToken) {
          cookies.set("auth_token", newToken, {
            path: "/",
            secure: process.env.NODE_ENV === "production",
            sameSite: "Strict",
          });

          axiosConfig.headers.Authorization = `Bearer ${newToken}`;
          return await axios(axiosConfig);
        }
      } catch (refreshError) {
        console.error("Token refresh failed in raw axios call:", refreshError);
        apiBase.logout();
        window.location.href = "/login";
        throw refreshError;
      }
    }

    throw error;
  }
};
